import { Component, EventEmitter, Output } from '@angular/core';
import { ImageCroppedEvent, ImageCropperModule } from 'ngx-image-cropper';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-cover-image-crop',
  standalone: true,
  imports: [CommonModule, ImageCropperModule],
  templateUrl: './cover-image-crop.component.html',
  styleUrls: ['./cover-image-crop.component.css']
})
export class CoverImageCropComponent {
  imageChangedEvent: any = null;
  croppedImage: string | null = null;
  showCropper = false;
  @Output() imageSaved = new EventEmitter<string>(); // Emit cropped image
  // Handle file input change
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.showCropper = true;
  }

  imageCropped(event: ImageCroppedEvent): void {
    this.croppedImage = event.base64 || null;
  }

  imageLoaded(): void {
    this.showCropper = true;
  }

  cropperReady(): void {
    // console.log('Cropper is ready'); //__CONSOLE_LOG__
  }

  loadImageFailed(): void {
    // console.error('Image load failed'); //__CONSOLE_LOG__
  }

  // Convert base64 to Blob
base64ToBlob(base64: string): Blob {
  const byteString = atob(base64.split(',')[1]);
  const mimeString = base64.split(',')[0].split(':')[1].split(';')[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
}

  saveCroppedImage(): void {
    // if (this.croppedImage) {
    //   const blob = this.base64ToBlob(this.croppedImage);
    //   const formData = new FormData();
    //   formData.append('image', blob, 'cover-image.jpg');
    //   // Send formData to backend
    // }
    if (this.croppedImage) {
      const blob = this.base64ToBlob(this.croppedImage);
      // console.log(blob); //__CONSOLE_LOG__
      
      this.imageSaved.emit(this.croppedImage); // Emit the cropped image
      this.showCropper = false; // Optionally hide cropper after saving
    }
  }
}